import { createContext, useContext } from 'react';
import type { SessionInfo } from '@oms/contracts';
import { hasPermission, type Permission } from '../lib/permissions';

export const SessionContext = createContext<SessionInfo | null>(null);

/** The signed-in session; only valid below a Require*Session guard. */
export function useCurrentSession(): SessionInfo {
  const s = useContext(SessionContext);
  if (!s) throw new Error('useCurrentSession must be used below a session guard');
  return s;
}

export function useCan(perm: Permission): boolean {
  return hasPermission(useCurrentSession().permissions, perm);
}
